<script lang="ts">
import { type Component, defineComponent } from 'vue';
import { formatDate } from '@/utils/format';
import MultisportScoreCricket from './MultisportScore.Cricket.vue';

export default defineComponent({
  name: 'BasketballMatchSummary',
  components: {
    MultisportScoreCricket,
  },
  computed: {
    data() {
      return this.update.Data;
    },
    teams() {
      return this.fixture.Name.includes(' v ')
        ? this.fixture.Name.split(' v ')
        : this.fixture.Competitors
          ? this.fixture.Competitors.length === 2
            ? [
                this.fixture.Competitors.find((c: { HomeAway: string }) => c?.HomeAway === 'Home')
                  ?.Name,
                this.fixture.Competitors.find((c: { HomeAway: string }) => c?.HomeAway === 'Away')
                  ?.Name,
              ]
            : this.fixture.Competitors.map((c: { Name: string }) => c?.Name)
          : ['Команда 1', 'Команда 2'];
    },
  },
  data() {
    return {
      sports: {
        6: MultisportScoreCricket,
      } as { [key: string]: Component },
    }
  },
  methods: {
    formatDate,
  },
  props: ['update', 'fixture'],
});
</script>

<template>
  <section v-if="update">
    <div
      :class="{
        'grid grid-flow-col w-max': true,
        '[grid-template-columns:repeat(auto-fit,max-content)]': true,
        'text-center border-gray-500': true,
        'custom-cells m-auto my-2': true,
      }"
      :style="`grid-template-rows: repeat(${teams.length + 1}, minmax(0, 1fr))`"
    >
      <div class="h">Фаза</div>
      <div class="b text-lg place-content-center" style="grid-row: 2/-1">
        {{ data.MatchPhase }}
      </div>

      <div class="h">Статус</div>
      <div class="b text-lg place-content-center" style="grid-row: 2/-1">
        {{ data.MatchStatus }}
      </div>

      <div class="!text-left h">Команды/Участники</div>
      <template v-for="(team, i) in teams" :key="team.Name">
        <div
          :class="{
            '!text-left': true,
            b: i === teams.length - 1,
          }"
        >
          {{ team }}
        </div>
      </template>

      <template v-if="sports[data.SportId]">
        <component :is="sports[data.SportId]" :data="data"/>
      </template>
      <template v-else>
        <div class="r h">Счет</div>
        <div class="r font-mono">{{ data?.HomeScore || '-' }}</div>
        <div class="r b font-mono">{{ data?.AwayScore || '-' }}</div>
      </template>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.custom-cells {
  & > div {
    @apply px-3 pt-2 pb-1 text-lg;
    @apply border border-gray-500;

    &:not(.r) {
      @apply border-r-0;
    }

    &:not(.b) {
      @apply border-b-0;
    }
  }

  & > div.h {
    @apply bg-gray-300 dark:bg-gray-700;
  }
}

</style>
